
import common from '@/utils/common'
import SectionRanking from '@/components/posts/SectionRanking.vue'
import SectionPosts from '@/components/posts/SectionPosts.vue'
import SectionSubs from '@/components/posts/SectionSubs.vue'
import SectionNotices from '@/components/posts/SectionNotices.vue'
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/chat/loding.vue';
import ScrollLoading from '@/components/scrollLoading.vue'
export default {
  auth: false,
  mixins: [common],
  components: {
    SectionRanking,
    SectionPosts,
    SectionSubs,
    SectionNotices,
    Loading,
    ScrollLoading
  },
  data() {
    return {
      menuIndex: 0,
      loading: false,
      activeMenuColor: '#C2DC00',
      categoryList: [
        { name: '전체', value: "" },
        { name: '집회활동', value: "집회활동" },
        { name: '애국활동', value: "애국활동" },
        { name: '마을활동', value: "마을활동" },
      ],
      rankings: [],
      listItems: {
        data: [],
        links: {},
        meta: {},
      },
      form: {
        board: '',
        category: '',
        page: 0,
        district_id: this.$store.state.district.id,
        word: this.$route.query.word ?? '',
      },
    }
  },
  computed: {
    ...mapGetters(['getPostColors', 'getPostMenuIndex']),

    styleObject() {
      return {
        '--menu-color': this.activeMenuColor
      }
    }
  },
  watch: {


  },
  methods: {
    //  이미지 태그 없애기
    removeImagesAndExtractText(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const images = doc.querySelectorAll('img');
      images.forEach(img => img.remove());
      return doc.body.textContent || "";
    },


    tabClick(data, category) {
      this.menuIndex = data
      this.form.category = category;
      this.FETCH_POST_MENU_INDEX(data);
      this.getActivityItems();
    },

    ...mapActions(['FETCH_POST_MENU_INDEX']),


    getActivityItems() {
      this.loading = true;
      this.form.page = 1;
      this.$axios.get("/api/post-activity", {
        params: this.form
      }).then(response => {
        this.listItems = response.data;
        this.loading = false;
      });
    },

    async loadMore() {
      const { data, meta } = this.listItems;
      if (meta.current_page <= meta.last_page) {
        this.form.page = meta.current_page + 1;
        this.$axios.get("/api/post-activity", {
          params: this.form
        }).then(response => {
          this.listItems = {
            data: [...data, ...response.data.data],
            links: response.data.links,
            meta: response.data.meta
          }
        });
      }
    },

    move(item) {
      this.$router.push({ path: `/activity/${item.id}`, query: { category: this.category, } });
    }

  },
  mounted() {
    if (this.$store.state.isFlutter && window.hideBtn) {
      window.hideBtn.postMessage(`hide:${this.$route.path}`);
    }
    this.getActivityItems();
    if (this.$route.query.board) {
      this.FETCH_POST_MENU_INDEX(Number(this.$route.query.board));
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!(from.fullPath.includes('posts') || from.fullPath.includes('create') || from.fullPath.includes('notices'))) {
        vm.FETCH_POST_MENU_INDEX(0);
      }
    });
  },
}
